export default __webpack_public_path__ + "static/media/request_prize-stap_03.c1ac7ca5.png";